import { Outlet } from 'react-router-dom'
import { GoBackProvider } from 'routes/GoBack'
import { UIFlex, UISkeleton } from 'components'
import { ErrorPage } from 'pages/ErrorPage'

import { AppBar } from '@interco/inter-ui/components/AppBar'
import IcArrowLeft from '@interco/icons/core/action-navigation/ic_arrow_left'
import IcHouse from '@interco/icons/core/action-navigation/ic_house'

import * as S from './styles'
import { useBasePage } from './useBasePage'

export const BasePage = () => {
  const { isLoading, isError, headerPage, goBack, onContinue } = useBasePage()

  // if (isKidsAccount) { isKidsAccount vem de useBasePage
  //   return <Feedback status="blockedKidsAccount" onContinue={onContinue} />
  // }

  if (isError) {
    return <ErrorPage onContinue={onContinue} />
  }

  return (
    <S.WrapperPage>
      <GoBackProvider />
      {isLoading ? (
        <UIFlex alignItems="center" justifyContent="center" height="var(--app-bar-height)">
          <UISkeleton width="200px" height="20px" />
        </UIFlex>
      ) : (
        <AppBar
          hideLeftIcon={!headerPage || headerPage.hideLeftButton}
          leftIcon={<IcArrowLeft height={24} width={24} color="#FF7A00" onClick={goBack} />}
          rightIcon={
            headerPage?.showRightButton && (
              <IcHouse height={24} width={24} color="#FF7A00" onClick={onContinue} />
            )
          }
        >
          {headerPage && headerPage.title}
        </AppBar>
      )}
      <Outlet />
    </S.WrapperPage>
  )
}
